import { render, staticRenderFns } from "./r-plinko-physics-config-dialog.vue?vue&type=template&id=6ee9f011&scoped=true"
import script from "./r-plinko-physics-config-dialog.vue?vue&type=script&lang=js"
export * from "./r-plinko-physics-config-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-plinko-physics-config-dialog.vue?vue&type=style&index=0&id=6ee9f011&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee9f011",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ee9f011')) {
      api.createRecord('6ee9f011', component.options)
    } else {
      api.reload('6ee9f011', component.options)
    }
    module.hot.accept("./r-plinko-physics-config-dialog.vue?vue&type=template&id=6ee9f011&scoped=true", function () {
      api.rerender('6ee9f011', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-plinko/r-plinko-physics-config-dialog.vue"
export default component.exports